import React, { useEffect, useMemo, useRef, useState } from "react";
import Config from "../../config/Config";
import { useAppSelector } from "../../core/feature/hooks";
import User from "../../core/models/user";
import TabsMobile from "../__template/TabsMobileComponent";
import users from "../../assets/images/icon_profile/user.svg";
import camera from "../../assets/images/icon_profile/Camera.svg";
import { useTranslation } from "react-i18next";
import { update } from "lodash";
import { getUser } from "../../core/service/api_card";
import { updateUser, uploadPhoto } from "../../core/service/api_profile";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { setLoading } from "../../core/feature/config/configSlice";
import { setUser } from "../../core/feature/user/userSlice";
import CustomApp from "../../core/models/customApp";
import { isDarkColor } from "../../config/DarkColorChecker";

const ComponentEditProfile = () => {
  const user: User = useAppSelector((state) => state.user.user);
  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const [inputActive, setInputActive] = useState(true);
  const [update, setUpdate] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const emailRef = useRef<HTMLInputElement>(null);
  const phoneRef = useRef<HTMLInputElement>(null);
  const [data, setData] = useState<any>({});
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const env = Config.BaseUrlDev;
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [previewImage, setPreviewImage] = useState<any>();
  const [image, setImage] = useState<any>();

  const getProfileImage = useMemo(() => {
    if (user?.photoUrl == "") {
      return users;
    }
    return env + "main_a/image/get/" + user?.photoUrl + "/pas";
  }, [user]);

  const updateData = async () => {
    const regexEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    if (email == "") return toast.warning(t("LOGIN.warningEmail"));
    if (phone == "") return toast.warning(t("LOGIN.warningWA"));

    if (email && !email.match(regexEmail))
      return toast.warning(t("LOGIN.warningEmail"));
    if (phone && phone.length < 10) return toast.warning(t("LOGIN.warningWA"));
    setData({
      ...data,
      email: email,
      phone: phone,
    });
    // setData({ ...data, phone: phoneRef.current?.value });
    setUpdate(true);
  };

  function getUserData() {
    getUser().then((res) => {
      setData(res.data);
      setEmail(res.data.email);
      setPhone(res.data.phone);
      dispatch(setUser(res.data));
    });
  }

  const handleClick = () => {
    inputRef?.current?.click();
  };
  const inputHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.currentTarget.files) {
      // you can display the error to the user
      console.error("Select a file");
      const enteredName = event?.currentTarget?.files[0];
      // setIsImage(enteredName.type.includes("image/"));
      setImage(enteredName);
      setPreviewImage(URL.createObjectURL(enteredName));
      // onClickUpdateImage();
      return;
    }
  };

  useEffect(() => {
    if (image != undefined) {
      dispatch(setLoading(true));
      uploadPhoto(image)
        .then((res) => {
          dispatch(setLoading(false));
          setData({
            ...data,
            photoUrl: res.data.name,
          });
          setUpdate(true);
        })
        .catch((err) => {
          dispatch(setLoading(false));
          console.log(err);
        });
    }
  }, [image]);

  useEffect(() => {
    if (update == true) {
      dispatch(setLoading(true));
      updateUser(data)
        .then((res: any) => {
          dispatch(setLoading(false));
          setInputActive(true);
          getUserData();
          setUpdate(false);
          toast.success(t("PROFILE.success"));
        })
        .catch((err) => {
          dispatch(setLoading(false));
        });
    }
  }, [update, data]);

  useEffect(() => {
    getUserData();
  }, []);
  return (
    <div className="min-h-screen h-full  bg-psp-primary">
      <div className={`px-8 pt-8 pb-3  sticky top-0 z-50 transparent`}>
        <TabsMobile
          name={
            isEdit == true
              ? `${t("EDIT-PROFILE.title")}`
              : `${t("EDIT-PROFILE.title2")}`
          }
          backUrl={"profile"}
        ></TabsMobile>
      </div>

      <section className="p-4 pt-0 top-to-bottom">
        <div
          className="flex justify-center relative"
          onClick={() => handleClick()}
        >
          <img
            src={previewImage || getProfileImage}
            className="w-36 h-36 relative rounded-full object-cover saturate-50 z-[1] "
          />
          <input
            type="file"
            ref={inputRef}
            accept="image/*"
            style={{ display: "none" }}
            onChange={inputHandler}
            placeholder="pilih foto"
          />
          <img
            src={camera}
            alt=""
            className="absolute z-[2] top-14 w-10 h-10"
          />
        </div>
        <div className="mt-2">
          <div className="flex flex-col gap-2">
            <h1 className="font-montserrat  text-sm text-black leading-5 font-medium pl-1 mb-0">
              Email
            </h1>
            <input
              type="text"
              value={email}
              disabled={inputActive}
              onChange={(e) => setEmail(e.target.value)}
              className="px-3 grow rounded-lg h-10 border-1 border-psp-gray border-solid disabled:text-psp-nav"
            />
          </div>
          <div className="flex flex-col gap-2 mt-2">
            <h1 className="font-montserrat text-sm text-black leading-5 font-medium pl-1 mb-0">
              {t("PROFILE.phone")}
            </h1>
            <input
              type="number"
              disabled={inputActive}
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="px-3 grow rounded-lg h-10 border-1 border-psp-gray border-solid disabled:text-psp-nav  "
            />
          </div>
          <button
            hidden={!inputActive}
            style={{ backgroundColor: customApp?.app_secondary_accent_color }}
            onClick={() => (setInputActive(false), setIsEdit(true))}
            className={`px-4 mt-3 font-medium text-sm items-center justify-center bg-yellow w-full flex flex-row rounded-lg gap-3 py-2.5 active:bg-yellow-active ${isDarkColor(customApp.app_secondary_accent_color)?'text-white':'text-black'}`}
          >
            {t("OTHER.edit")}
          </button>

          <button
            hidden={inputActive}
            onClick={() => (updateData(), setIsEdit(false))}
            style={{ backgroundColor: customApp?.app_accent_color }}
            className={`px-4 mt-3 font-medium text-sm items-center justify-center  w-full flex flex-row rounded-lg gap-3 py-2.5 active:bg-psp-active ${isDarkColor(customApp.app_accent_color)?'text-white':'text-black'}`}
          >
            {t("OTHER.save")}
          </button>
        </div>
      </section>
    </div>
  );
};

export default ComponentEditProfile;
